module.exports = __webpack_public_path__ + "static/media/reroute_link.0f828127.png";